export default __webpack_public_path__ + "static/media/web-about.317cbfa9.webm";